import phpClient from '../phpAPI_Config'
import { tsWhoAmI } from '../../../Typescript/API_Response'

async function getWhoAmI() {
  return await phpClient()
    .get<any>(`/whoami.php`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function setUserPref(authState: tsWhoAmI, name: string, value: any) {
  return await phpClient(authState)
    .get<any>(
      `/json/stuart/generic/setUserPref.php?PrefName=${name}&PrefValue=${value}`,
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function getAtLoginConfig(authState: tsWhoAmI) {
  return await phpClient(authState)
    .get<any>(`/json/stuart/generic/getAtLoginConfig.php`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

const UserService = {
  getWhoAmI,
  getAtLoginConfig,
  setUserPref,
}

export default UserService
